package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.GameTableRepository

class SetTableMemberCharacterUseCase(
    private val gameTableRepository: GameTableRepository
) {
    suspend operator fun invoke(
        tableId: String,
        userId: String,
        characterId: String
    ): Result<Unit> {
        return gameTableRepository.updateMemberCharacter(
            tableId = tableId,
            userId = userId,
            characterId = characterId
        )
    }
}
